import React from "react";
import * as Realm from "realm-web";
import { useCollection } from "./useCollection";
import { useRealmApp } from "../components/RealmApp";
import Config from "../shared/Config";
const { dataSourceName } = Config();


export function useUsers() {
  const realmApp = useRealmApp();
  const { currentUser } = realmApp;
  const [userSaved, setUserSaved] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);
  const [user, setUser] = React.useState({});

  const collection = useCollection({
    cluster: dataSourceName,
    db: "ecommdb",
    collection: "users"
  });

  React.useEffect(() => {
    collection.aggregate([{
      $lookup:
        {
          from: "stores",
          localField: "id",
          foreignField: "admins",
          as: "stores"
        }
   }]).then((res) => {
    const [user] = res
      console.log('useUsers.js fetch:mongo', {user});
      setUser(user);
      setLoaded(true);
    });
  }, [collection]);

  const upsertUser = async ({ venmo, fullname }) => {
    const _partition = realmApp.currentUser.id;
    const id = realmApp.currentUser.id;

    await collection.updateOne(
      { id: id },
      { $set: { id, venmo, fullname, _partition } },
      { upsert: true }
    );
    setUserSaved(true);
    setUser({ id, venmo, fullname, _partition });
  };

  // build and insert an order
  const insertUser = async (user) => {
    if (user.id) {
      user._id = new Realm.BSON.ObjectID();
      user._partition = realmApp.currentUser.id;
      user.id = realmApp.currentUser.id;
      try {
        //console.log({ order })
        await collection.insertOne(user);
        setUserSaved(true);
      } catch (err) {
        if (err.error.match(/^Duplicate key error/)) {
          console.warn(
            `The following error means that we tried to insert a todo multiple times (i.e. an existing todo has the same _id). In this app we just catch the error and move on. In your app, you might want to debounce the save input or implement an additional loading state to avoid sending the request in the first place.`
          );
        }
        console.error(err);
      }
    }
  };

  const updateUserInfo = async (user, venmo, fullname) => {
    await collection.updateOne(
      { _id: user._id },
      { $set: { venmo, fullname } }
    );
  };

  // const deleteUser = async (user) => {
  //   await collection.deleteOne({ _id: user.id });
  // };

  return {
    user,
    currentUser,
    loaded,
    userSaved,
    upsertUser,
    insertUser,
    updateUserInfo,
  };
}
